export function transition(attributes: string[]) {
  return attributes.map(attr => `${attr} 30ms ease-out`).join(",")
}

export function transitionMid(attributes: string[]) {
  return attributes.map(attr => `${attr} 60ms ease-out`).join(",")
}

export function transitionSlow(attributes: string[]) {
  return attributes.map(attr => `${attr} 100ms ease-out`).join(",")
}
